"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var StyledCard = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  display: ", ";\n\n  position: relative;\n\n  padding-top: ", ";\n  .content {\n    position: relative;\n    padding: ", ";\n    z-index: 1;\n    border-radius: ", "px;\n    background: ", ";\n    color: ", ";\n    &:before,\n    &:after {\n      background: ", ";\n      content: \"\";\n      position: absolute;\n      right: 0;\n      width: ", ";\n      opacity: 0.4;\n      border-radius: ", "px;\n      z-index: -1;\n    }\n    &:before {\n      ", "\n    }\n    &:after {\n      ", "\n    }\n  }\n"], ["\n  width: ", ";\n  display: ", ";\n\n  position: relative;\n\n  padding-top: ", ";\n  .content {\n    position: relative;\n    padding: ", ";\n    z-index: 1;\n    border-radius: ", "px;\n    background: ", ";\n    color: ", ";\n    &:before,\n    &:after {\n      background: ", ";\n      content: \"\";\n      position: absolute;\n      right: 0;\n      width: ", ";\n      opacity: 0.4;\n      border-radius: ", "px;\n      z-index: -1;\n    }\n    &:before {\n      ", "\n    }\n    &:after {\n      ", "\n    }\n  }\n"])), function (props) { return (props.inline ? "auto" : "100%"); }, function (props) { return (props.inline ? "inline-block" : "block"); }, function (props) {
    switch (props.wings) {
        case "large":
            return "73px";
        case "small":
            return "22px";
        case "hidden":
        default:
            return "0";
    }
}, function (props) {
    if (props.inline) {
        return "10px 15px";
    }
    return "15px 20px";
}, function (props) { return props.theme.cardRadius; }, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__cardBackgroundColor, theme.cardBackgroundColor);
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.gray1);
}, function (_a) {
    var wings = _a.wings, theme = _a.theme;
    if (wings) {
        return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__cardBackgroundColor, theme.cardBackgroundColor);
    }
    return "transparent";
}, function (props) {
    if (props.theme.cardRadius !== undefined) {
        return "calc(100% - ".concat(props.theme.cardRadius / 1.5, "px)");
    }
    return "auto";
}, function (props) { return props.theme.cardRadius; }, function (_a) {
    var wings = _a.wings;
    if (wings && wings === "large") {
        return "\n          height: calc(100% + 33px);\n            top: -33px;\n            clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 33px);\n          ";
    }
    if (wings && wings === "small") {
        return "\n            height: calc(100% + 10px);\n            top: -10px;\n            clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 10px);\n          ";
    }
}, function (_a) {
    var wings = _a.wings;
    if (wings && wings === "large") {
        return "\n            height: calc(100% + 72px);\n            top: -72px;\n            clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 72px);\n          ";
    }
    if (wings && wings === "small") {
        return "\n            height: calc(100% + 22px);\n            top: -22px;\n            clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 22px);\n          ";
    }
});
var Card = function (_a) {
    var wings = _a.wings, children = _a.children, style = _a.style, inline = _a.inline, _b = _a.className, className = _b === void 0 ? "" : _b;
    return ((0, jsx_runtime_1.jsx)(StyledCard, __assign({ wings: wings, style: style, inline: inline, className: "wellms-component ".concat(className) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "content" }, { children: children })) })));
};
exports.Card = Card;
var templateObject_1;
